import React from 'react';
import SystemAdminDashboardPage from './SystemAdminDashboardPage';
import {
  getStatisticsReport,
  downloadStatisticsReport,
} from '../../../api/statisticsReportApi';
import { useTranslation } from 'react-i18next';
import { sendLicenseEmail } from '../../../api/department';
import noti from '../../../actions/toast';

const textCenter = { textAlign: 'center', whiteSpace: 'nowrap' };

const SystemAdminDashboard = () => {
  const { t } = useTranslation('app');
  const [statistics, updateStatistics] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [isDownloading, setIsDownloading] = React.useState(false);
  const [isSending, setIsSending] = React.useState(false);
  const [errors, setErrors] = React.useState('');
  React.useEffect(() => {
    setLoading(true);
    getStatisticsReport()
      .then((resp) => updateStatistics(resp))
      .catch((err) => setErrors(err))
      .finally(() => setLoading(false));
  }, []);
  const columns = [
    {
      dataField: 'departmentName',
      text: 'Department Name',
      sort: true,
    },
    {
      dataField: 'departmentUsage',
      text: 'Department Usage',
      sort: true,
      sortFunc: customSortFunction,
    },
    {
      dataField: 'departmentUsagePercentage',
      text: 'Department Usage %',
      sort: true,
      sortFunc: customSortFunction,
    },
    {
      dataField: 'userCount',
      text: 'Users',
      sort: true,
      headerStyle: textCenter,
      align: 'center',
      headerTitle: () =>
        t('Active / Max License / Total (Active and Inactive)'),
      formatter: (cell, row) =>
        `${row.activeUserCount} / ${row.maxLicensedUserCount} / ${row.totalUserCount}`,
      sortFunc: sortUsers,
    },
    // {
    //   dataField: 'activeUserCount',
    //   text: 'Active User Count',
    //   sort: true,
    // },
    // {
    //   dataField: 'inactiveUserCount',
    //   text: 'Inactive User Count',
    //   sort: true,
    // },
    {
      dataField: 'lockedUserCount',
      text: 'Locked User Count',
      sort: true,
    },
    {
      dataField: 'passwordExpiredUserCount',
      text: 'Password Expired User Count',
      sort: true,
      headerStyle: { width: '10%' },
    },
    {
      dataField: 'disableSensorCount',
      text: 'Disable Sensor Count',
      sort: true,
    },
    {
      dataField: 'sensorCount',
      text: 'Sensor Count',
      sort: true,
    },
    {
      dataField: 'oldestData',
      text: 'Oldest Data',
      sort: true,
      isDateTime: true,
    },
  ];
  const defaultSorted = [
    {
      dataField: 'departmentName',
      order: 'asc',
    },
  ];

  function parseNumber(str) {
    if (str) {
      return parseFloat(str.split(' ')[0]);
    } else {
      return 0.0;
    }
  }
  function parseUnlimited(str) {
    if (str === 'Unlimited') {
      return 99999;
    } else {
      return parseFloat(str);
    }
  }
  function customSortFunction(a, b, order) {
    if (order === 'asc') {
      return parseNumber(a) - parseNumber(b);
    } else if (order === 'desc') {
      return parseNumber(b) - parseNumber(a);
    }
  }
  function sortUsers(a, b, order, datafield, rowA, rowB) {
    if (order === 'asc') {
      return (
        parseUnlimited(rowA.maxLicensedUserCount) -
        parseUnlimited(rowB.maxLicensedUserCount)
      );
    } else if (order === 'desc') {
      return (
        parseUnlimited(rowB.maxLicensedUserCount) -
        parseUnlimited(rowA.maxLicensedUserCount)
      );
    }
  }
  async function handleExport(format) {
    setIsDownloading(true);
    downloadStatisticsReport(format)
      .then(() => {})
      .catch((err) => setErrors(err))
      .finally(() => setIsDownloading(false));
  }
  function onSendLicenseEmail() {
    setIsSending(true);
    sendLicenseEmail()
      .then(() => {
        noti.success('Email Sent');
      })
      .catch((err) => setErrors(err))
      .finally(() => setIsSending(false));
  }
  return (
    <SystemAdminDashboardPage
      loading={loading}
      statistics={statistics}
      datagridProps={{ columns, defaultSorted }}
      onExport={handleExport}
      isSending={isSending}
      onSendLicenseEmail={onSendLicenseEmail}
    />
  );
};

export default SystemAdminDashboard;
